import styled from 'styled-components'

export const CustomCompleteAnatomyContainer = styled.div`
  h4 {
    font-weight: 500;
    font-size: 21px;
    color: var(--grey);
    margin-bottom: 1.5rem;
  }

  p {
    margin-bottom: 2rem;
    line-height: 22px;
  }
`
